import {
  createLoadingStatusActionGroup,
  createLoadingStatusActionGroupWithResponse
} from '~/shared/helpers/loading-status-helper';
import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { EntityId, Instrument, PricePeriod, PriceSeries } from '@qvs/core';
import { Update } from '@ngrx/entity';

const source = 'Instrument';
const prefix = `[${source}]`;

export const {
  load: loadInstrumentList,
  success: loadInstrumentListSuccess,
  failure: loadInstrumentListFailure
} = createLoadingStatusActionGroup(prefix, 'instrument list');

export const { loadInstrumentLastPriceList, loadInstrumentLastPriceListSuccess, loadInstrumentLastPriceListFailure } =
  createActionGroup({
    source,
    events: {
      'load instrument last price list': props<{ instruments: Instrument[] }>(),
      'load instrument last price list success': props<{ instruments: Instrument[] }>(),
      'load instrument last price list failure': props<{ instruments: Instrument[] }>()
    }
  });

export const { loadInstrumentSixDetails, loadInstrumentSixDetailsSuccess, loadInstrumentSixDetailsFailure } = createActionGroup({
  source,
  events: {
    'load instrument Six details': props<{ instrument: Instrument }>(),
    'load instrument Six details success': props<{ instrument: Instrument }>(),
    'load instrument Six details failure': props<{ instrument: Instrument }>()
  }
});

export const {
  load: loadWatchlist,
  success: loadWatchlistSuccess,
  failure: loadWatchlistFailure
} = createLoadingStatusActionGroupWithResponse<{ currentlyWatchedIds: EntityId[] }>(prefix, 'watchlist');

export const { addToWatchlist, addToWatchlistSuccess, addToWatchlistFailure } = createActionGroup({
  source,
  events: {
    'add to watchlist': props<{ instrumentId: EntityId }>(),
    'add to watchlist success': props<{ instrumentId: EntityId; watchlistId: number }>(),
    'add to watchlist failure': emptyProps()
  }
});

export const { removeFromWatchlist, removeFromWatchlistSuccess, removeFromWatchlistFailure } = createActionGroup({
  source,
  events: {
    'remove from watchlist': props<{ instrumentId: EntityId; watchlistId: number }>(),
    'remove from watchlist success': props<{ instrumentId: EntityId }>(),
    'remove from watchlist failure': emptyProps()
  }
});

export const { getInstrumentDetails, loadInstrumentDetails, loadInstrumentDetailsSuccess, loadInstrumentDetailsFailure } =
  createActionGroup({
    source,
    events: {
      'get instrument details': props<{ instrumentId: EntityId }>(),
      'load instrument details': props<{ instrumentId: EntityId }>(),
      'load instrument details success': props<{ instrumentId: EntityId }>(),
      'load instrument details failure': props<{ instrumentId: EntityId }>()
    }
  });

export const { loadPrices, loadPricesSuccess, loadPricesFailure } = createActionGroup({
  source,
  events: {
    'load prices': props<{ instrumentId: EntityId; period: Uppercase<PricePeriod> }>(),
    'load prices success': props<{ instrumentId: EntityId; period: Uppercase<PricePeriod>; priceSeries: PriceSeries }>(),
    'load prices failure': props<{ period: Uppercase<PricePeriod> }>()
  }
});

export const { updateInstruments, upsertInstruments } = createActionGroup({
  source,
  events: {
    'update instruments': props<{ updates: Update<Instrument>[] }>(),
    'upsert instruments': props<{ entities: Instrument[] }>()
  }
});

export const { updateInstrument, upsertInstrument } = createActionGroup({
  source,
  events: {
    'update instrument': props<Update<Instrument>>(),
    'upsert instrument': props<{ entity: Instrument }>()
  }
});

export const loadIntraDayPricesSuccess = createAction(`${prefix} load intra-day prices success`);

export const setCurrentInstrumentId = createAction(`${prefix} set current instrument ID`, props<{ instrumentId: EntityId }>());
